import { getPoListThunkAndSlice } from "./poListSlice";

export interface IPoCategory {
	Cat_ID: number;
	Cat_Desc: string;
	Cat_Type: string;
}

export const { thunk: listPoCategories, slice: listPoCategoriesSlice } = getPoListThunkAndSlice<IPoCategory>({
	name: "poCategories",
	path: "/api/Purchasing/ListCategories",
	fallbackPath: "/api/Pricing/ListCategories",
});
